/* eslint-disable no-useless-constructor */
export const Operation = {
  REFUND: 'REFUND',
  NOT_REFUNDABLE: 'NOT_REFUNDABLE',
  PAYMENT: 'PAYMENT',
  NOT_OPERATION: 'NOT_OPERATION',
  REFUND_FREE: 'REFUND_FREE',
  PAYMENT_FREE: 'PAYMENT_FREE'
};

export class FlightGroupModel {
  constructor(
    flightNumber,
    hasExchangeAirport,
    destination,
    departureDate,
    departureTime,
    arrivalDate,
    arrivalTime,
    marketingCarrier,
    dateVariation,
    origin,
    operatingCarrier,
    throughFlight
  ) {}
}

export class FlightDotModel {
  constructor(isRed, value) {}
}

export class FlightConnectionsModel {
  constructor(id, numberInfo, dot, isRed) {}
}

export class Flight {
  constructor(
    originAirport,
    originAirportName,
    finalDestination,
    finalDestinationName,
    flightGroup,
    category,
    baggage,
    total,
    hasExchangeAirport,
    throughFlight,
    departureDate,
    prices,
    money,
    departureTime,
    finalArrivalDate,
    finalArrivalTime,
    dateVariation
  ) {}
}



// WEBPACK FOOTER //
// ./src/const/FlightModel.js